import React from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import { Sugar } from 'react-preloaders';
import {
  BrowserRouter as Router, Route, Switch
} from "react-router-dom";
import './App.css';
import About from './Component/About/About';
import Blog from './Component/Blog/Blog';
import Contact from './Component/Contact/Contact';
import Dashboard from './Component/Dashboard/Dashboard';
import NotFound from './Component/NotFound.js/NotFound';
import Portfolio from './Component/Portfolio/Portfolio';

function App() {
  return (
    <Router>
      <div>
        <Sugar />
        <Switch>
          <Route exact path="/">
            <Dashboard />
          </Route>
          <Route path="/home">
            <Dashboard />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/portfolio">
            <Portfolio />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
        <MessengerCustomerChat
          pageId="103651764337058"
          appId="3008153152774673"
        />
      </div>
    </Router>
  );
}

export default App;
